// ============================================================================
// avecRessync: teto das novas tentativas de um MÊS FECHADO que ficou com
// relatório faltando (revisão 23/10/2026 do "Dashboard sem zero silencioso",
// achados 4, 11 e 19). Puro (o localStorage fica com quem chama).
// ============================================================================
// Antes desta rodada o mês fechado virava snapshot logo no 1º sync depois da
// virada e nunca mais era buscado. Com o estado da coleta, mês com falha não
// vira snapshot e o syncLast12IfNeeded o refazia a CADA abertura do app em cada
// aparelho (~290 pedidos por mês travado, sem fim se a falha fosse estrutural).
// Agora, por aparelho e por mês:
//   - no máximo 1 nova tentativa a cada 12 h (intervaloMs);
//   - depois de 3 tentativas (maxTentativas) desiste: o mês vira snapshot com o
//     que veio (as falhas continuam marcadas em _falhas/_coleta da unidade, que
//     vão junto para o snapshot) e para de gerar chamadas.
// Marca no aparelho: localStorage[CHAVE_RESSYNC] = { 'YYYY-MM': { n, at } }
// (chave só do aparelho, não vai para a nuvem).
// ============================================================================

export const CHAVE_RESSYNC = 'fk_avec_ressync_mes';
export const RESSYNC_MES = Object.freeze({ intervaloMs: 12 * 3600_000, maxTentativas: 3 });

export function lerMarcasRessync(raw) {
  try {
    const o = JSON.parse(raw || '{}');
    return o && typeof o === 'object' && !Array.isArray(o) ? o : {};
  } catch { return {}; }
}

/** 'refazer' | 'esperar' | 'consolidar' (desistiu: vira snapshot com o que veio). */
export function decidirRessync(marca, agora = Date.now(), regras = RESSYNC_MES) {
  if (!marca || typeof marca !== 'object') return 'refazer';
  const n = Number(marca.n) || 0;
  const at = Number(marca.at) || 0;
  if (n >= regras.maxTentativas) return 'consolidar';
  if (agora - at < regras.intervaloMs) return 'esperar';
  return 'refazer';
}

export function registrarTentativa(marcas, chave, agora = Date.now()) {
  const m = (marcas && marcas[chave]) || {};
  return { ...(marcas || {}), [chave]: { n: (Number(m.n) || 0) + 1, at: agora } };
}

/** Meses em que o aparelho já desistiu (podem virar snapshot mesmo com falha). */
export function mesesParaConsolidarComFalha(marcas, regras = RESSYNC_MES) {
  return new Set(Object.entries(marcas || {}).filter(([, m]) => (Number(m?.n) || 0) >= regras.maxTentativas).map(([k]) => k));
}

/** Tira marcas de meses que já viraram snapshot ou saíram da janela de 12 meses. */
export function limparMarcas(marcas, manter = () => true) {
  const out = {};
  for (const [k, v] of Object.entries(marcas || {})) if (manter(k)) out[k] = v;
  return out;
}
